import { AuthConfig } from 'angular-oauth2-oidc';

export const authConfig: AuthConfig = {
  issuer: 'https://sigma-staging.tamiin.com/',
  // issuer: 'https://innovastrasigma.azurewebsites.net/',
  loginUrl: 'https://sigma-staging.tamiin.com/connect/authorize',
  // loginUrl: 'https://innovastrasigma.azurewebsites.net/connect/authorize',
  tokenEndpoint: 'https://sigma-staging.tamiin.com/connect/token',
  // tokenEndpoint: 'https://innovastrasigma.azurewebsites.net/connect/token',
  clientId: 'tamiin.web',
  dummyClientSecret: 'tamiin_web_secret', // optional for public clients
  redirectUri: window.location.origin,
  responseType: 'code',
  scope: 'openid profile role permission offline_access ', //   added offline_access
  showDebugInformation: true,
};
